// Константы, дублирующие значения из ScroogeFinance.sol — для UI
export const MIN_STAKE_USDT = 5; // MIN_DEPOSIT = 5 ether в контракте
export const MIN_STAKE_WEI = 5n * 10n ** 18n;
export const PROTOCOL_FEE_BPS = 1000; // 10%
export const BPS_DENOM = 10_000;
export const REWARD_TIERS_COUNT = 17;
export const SPONSOR_GRACE_PERIOD_SEC = 7 * 24 * 60 * 60;
export const MAX_POSITIONS_PER_USER = 500;

// 17-tier rewards схема (% из пула протокола, не из стейка партнёра)
export const REWARD_TIERS = [
  { tier: 1,  bps: 2000, label: '20%' },
  { tier: 2,  bps: 1000, label: '10%' },
  { tier: 3,  bps: 500,  label: '5%' },
  { tier: 4,  bps: 500,  label: '5%' },
  { tier: 5,  bps: 500,  label: '5%' },
  { tier: 6,  bps: 500,  label: '5%' },
  { tier: 7,  bps: 500,  label: '5%' },
  { tier: 8,  bps: 300,  label: '3%' },
  { tier: 9,  bps: 300,  label: '3%' },
  { tier: 10, bps: 300,  label: '3%' },
  { tier: 11, bps: 100,  label: '1%' },
  { tier: 12, bps: 100,  label: '1%' },
  { tier: 13, bps: 100,  label: '1%' },
  { tier: 14, bps: 100,  label: '1%' },
  { tier: 15, bps: 100,  label: '1%' },
  { tier: 16, bps: 100,  label: '1%' },
  { tier: 17, bps: 100,  label: '1%' },
];

// Backward-compat aliases (не использовать в новом коде)
export const MIN_DEPOSIT_USDT = MIN_STAKE_USDT;
export const MIN_DEPOSIT_WEI = MIN_STAKE_WEI;
export const TREASURY_FEE_BPS = PROTOCOL_FEE_BPS;
export const REFERRAL_LEVELS = REWARD_TIERS_COUNT;
export const MAX_DEPOSITS_PER_USER = MAX_POSITIONS_PER_USER;
export const REFERRAL_GENERATIONS = REWARD_TIERS.map((t) => ({
  gen: t.tier,
  bps: t.bps,
  label: t.label,
}));
